import {
    ResourceActivityNotificationPreferences,
    ResourceActivityPage,
    ResourceActivityResourceType,
    ResourceActivitySubscriber,
    ResourceHistoryPage,
    ResourceVersionListItem,
    VersionedResourceType,
} from '@/types';

import { apiClient } from '../http';

export type ResourceActivityListParams = {
    cursor?: string;
    includeNested?: boolean;
    limit?: number;
    order?: 'newest' | 'oldest';
};

export type ResourceActivitySubscriptionInput = {
    notificationPreferences?: ResourceActivityNotificationPreferences;
    subscribed?: boolean;
};

export type ResourceHistoryListParams = {
    cursor?: string;
    limit?: number;
};

export const resourceActivityService = {
    export: (resourceType: ResourceActivityResourceType, resourceId: string) =>
        apiClient.get<Blob>(`/api/resource-activities/${resourceType}/${resourceId}/export`, { responseType: 'blob' }),
    list: (resourceType: ResourceActivityResourceType, resourceId: string, params?: ResourceActivityListParams) =>
        apiClient.get<ResourceActivityPage, ResourceActivityListParams>(
            `/api/resource-activities/${resourceType}/${resourceId}`,
            { params },
        ),
    listSubscribers: (resourceType: ResourceActivityResourceType, resourceId: string) =>
        apiClient.get<ResourceActivitySubscriber[]>(
            `/api/resource-activities/${resourceType}/${resourceId}/subscribers`,
        ),
    listHistory: (resourceType: VersionedResourceType, resourceId: string, params?: ResourceHistoryListParams) =>
        apiClient.get<ResourceHistoryPage, ResourceHistoryListParams>(
            `/api/resource-activities/${resourceType}/${resourceId}/history`,
            { params },
        ),
    getHistoryVersion: (resourceType: VersionedResourceType, resourceId: string, versionId: string) =>
        apiClient.get<ResourceVersionListItem>(
            `/api/resource-activities/${resourceType}/${resourceId}/history/${versionId}`,
        ),
    markRead: (resourceType: ResourceActivityResourceType, resourceId: string) =>
        apiClient.put<ResourceActivitySubscriber>(`/api/resource-activities/${resourceType}/${resourceId}/read`),
    restoreHistoryVersion: (resourceType: VersionedResourceType, resourceId: string, versionId: string) =>
        apiClient.post<ResourceVersionListItem>(
            `/api/resource-activities/${resourceType}/${resourceId}/history/${versionId}/restore`,
            {},
        ),
    updateSubscription: (
        resourceType: ResourceActivityResourceType,
        resourceId: string,
        input: ResourceActivitySubscriptionInput,
    ) =>
        apiClient.put<ResourceActivitySubscriber, ResourceActivitySubscriptionInput>(
            `/api/resource-activities/${resourceType}/${resourceId}/subscription`,
            input,
        ),
};
